import Http from '../request-method.js';

export default {
     
    selectMatchList(){
        return Http.get('/ContestantApi/SelectMatchList');
    },

    getUnitInfo() {
        return Http.get('/ContestantApi/GetUnitInfo');
    },

    editUnitInfo(data) {
        return Http.post('/ContestantApi/EditUnitInfo',data);
    },

    selectUnitAthletes(data) {
        return Http.post('/ContestantApi/SelectUnitAthletes', data);
    },
    editUnitAthlete(data){
        return Http.post('/ContestantApi/EditUnitAthlete', data);
    },
    delUnitStaff(data) {
        return Http.get('/ContestantApi/DelUnitStaff', data);
    },
    selectUnitTeamLeaders(data) {
        return Http.post('/ContestantApi/SelectUnitTeamLeaders', data);
    },
    editUnitTeamLeader(data){
        return Http.post('/ContestantApi/EditUnitTeamLeader', data);
    },
    selectUnitTeams(data) {
        return Http.post('/ContestantApi/SelectUnitTeams', data);
    },
    editUnitTeam(data){
        return Http.post('/ContestantApi/EditUnitTeam', data);
    },
    getMatchDetail(data){
        return Http.get('/ContestantApi/GetMatchDetail', data);
    },
    submitMatchSignUpForm(data){
        return Http.post('/ContestantApi/SubmitMatchSignUpForm', data);
    },
    checkUnitIsSignUp(data) {
        return Http.get('/ContestantApi/CheckUnitIsSignUp', data);
    },
    getUnitMatchSignUpForm(data) {
        return Http.get('/ContestantApi/getUnitMatchSignUpForm', data);
    },
    selectSignUpForms(data){
        return Http.post('/ContestantApi/SelectSignUpForms', data);
    },
    getUnitMatchScore(data) {
        return Http.get('/ContestantApi/GetUnitMatchScore', data);
    },
    setMatchSignUpFormReceiptFileIds(data){
        return Http.get('/ContestantApi/SetMatchSignUpFormReceiptFileIds', data);
    }
}